// extracted by mini-css-extract-plugin
module.exports = {"container":"userCard_container__3-dV7","loading":"userCard_loading__2vF_Q","content":"userCard_content__MixYn","status":"userCard_status__ltiaB"};